var initialState = {
  userName: '未登录用户',
  status: 'unknow',
  verificationType: 0,
  verificationStatus: 0,
  inWhiteList: false
};

var passport = function passport() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'passport.offline':
      {
        return {
          userName: '未登录用户',
          status: 'offline',
          verificationType: 0,
          verificationStatus: 0,
          inWhiteList: false
        };
      }

    case 'passport.online':
      {
        return {
          userName: action.userName || '',
          status: 'online',
          verificationType: action.verificationType || 0,
          verificationStatus: action.verificationStatus || 0,
          inWhiteList: action.inWhiteList || false
        };
      }

    default:
      return state;
  }
};

export default {
  passport: passport
};